const OrderEmbarcador = () => import(/* webpackChunkName: "admin" */ '@/components/admin/Orders')
const OrderEmbarcadorIndex = () => import(/* webpackChunkName: "admin" */ '@/components/admin/orders_embarcador/Index')

export default {
  children: [
    {
      component: OrderEmbarcadorIndex,
      meta: {
        breadcrumbs: [
          {link: '/admin', name: 'Administração'},
          {name: 'Orders Embarcador'},
        ]
      },
      path: '/'
    },
  ],
  component: OrderEmbarcador,
  path: 'orders_embarcador',
}
